import { render, staticRenderFns } from "./ConfigureChrome.vue?vue&type=template&id=5b254424&"
import script from "./ConfigureChrome.vue?vue&type=script&lang=js&"
export * from "./ConfigureChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports